<template>
	<div class="input">
		<input v-model.string="inputVal" v-on:blur="handleBlur()" type="text" :class="inputClass" :placeholder="placeholder"/>
		<inputAlert :error="error"/>
	</div>
</template>

<script>
import inputAlert from './input-alert'
export default {
	components:{
		inputAlert,
	},
	props:{
		blur: Function,
		error: String,
		placeholder: String,
		value: String,
	},
	computed:{
		inputClass: function(){
			return `form-control form-control-sm ${this.error? 'is-invalid': ''}`
		},

		// the following is needed to allow the parent to bind to this value
		// https://stackoverflow.com/questions/47311936/v-model-and-child-components
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods:{
  	handleBlur: function(){
  		if (this.blur) this.blur()
  	}
  }
}
</script>

<style scoped>
.input{position:relative;}
</style>


// WEBPACK FOOTER //
// src/components/form/input-text.vue